import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e36581bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salvar permissões", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ss-tela-conteudo" }
const _hoisted_7 = { class: "ss-card ss-card-space" }
const _hoisted_8 = { class: "ant-row ant-form-vertical" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_10 = { class: "ant-row ant-form-vertical" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_12 = { class: "ant-col ant-col-xs-20 ant-col-xl-8" }
const _hoisted_13 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_14 = { class: "ss-card ss-card-space" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "ant-row ant-form-vertical"
}
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_18 = { class: "ant-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-12 ant-col-xl-3",
  style: {"padding-top":"3px"}
}, " Ações em massa: ", -1))
const _hoisted_20 = { class: "ant-col ant-col-xs-12 ant-col-xl-2" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-12 ant-col-xl-1",
  style: {"padding-top":"3px"}
}, " em ", -1))
const _hoisted_22 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ant-col ant-col-xs-12 ant-col-xl-2",
  style: {"padding-top":"3px"}
}, " no módulo ", -1))
const _hoisted_24 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1" }, null, -1))
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "ant-row ss-borda-inferior" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-9" }, null, -1))
const _hoisted_31 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_37 = ["id"]
const _hoisted_38 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_40 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_41 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
    /*#__PURE__*/_createElementVNode("span")
  ])
], -1))
const _hoisted_45 = {
  class: "ant-row",
  style: {"text-align":"left"}
}
const _hoisted_46 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_usuario = _resolveComponent("selecionar-usuario")!
  const _component_barra_progresso = _resolveComponent("barra-progresso")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: _ctx.telaBase.identificadorRecurso,
          tituloRecurso: 'Controle de permissões',
          exibirAtalhosTela: true,
          exibirHistoricoTela: true,
          empresasSelecionadas: _ctx.telaBase.empresasSelecionadas,
          "onUpdate:empresasSelecionadas": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
        }, {
          BotoesAcoes: _withCtx(() => [
            _withDirectives(_createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.salvarPermissoes && _ctx.salvarPermissoes(...args))),
              type: "button",
              class: "ant-btn ant-btn-primary ss-btn-acao-destaque"
            }, _hoisted_5, 512), [
              [_vShow, _ctx.state.permiteSalvarPermissoes]
            ])
          ]),
          _: 1
        }, 8, ["identificadorRecurso", "empresasSelecionadas"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_a_form_item, {
                  label: "Empresas",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      class: "ss-tamanho-completo",
                      placeholder: "Selecione uma empresa",
                      value: _ctx.state.codigoEmpresa,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.codigoEmpresa) = $event)),
                      optionFilterProp: "label",
                      options: _ctx.telaBase.empresasDisponiveis,
                      onChange: _ctx.atualizarSelecaoEmpresa
                    }, null, 8, ["value", "options", "onChange"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_a_form_item, {
                  label: "Usuário",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_selecionar_usuario, {
                      empresas: [_ctx.state.codigoEmpresa],
                      codigoSelecionado: _ctx.state.codigoUsuario,
                      "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.codigoUsuario) = $event)),
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.obterControlePermissoesUsuario(_ctx.state.codigoUsuario)))
                    }, null, 8, ["empresas", "codigoSelecionado"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_a_form_item, {
                  label: "Perfil",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      class: "ss-tamanho-completo",
                      placeholder: _ctx.state.permiteAlteracaoPerfil ? 'Defina um perfil' : '',
                      value: _ctx.state.codigoPerfilUsuario > 0 ? _ctx.state.codigoPerfilUsuario : undefined,
                      optionFilterProp: "label",
                      onChange: _ctx.confirmeAlteracaoPerfil,
                      options: _ctx.state.listaPerfis,
                      disabled: !_ctx.state.permiteAlteracaoPerfil
                    }, null, 8, ["placeholder", "value", "onChange", "options", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_a_form_item, {
                  label: " ",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "ant-btn ant-btn-secondary",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.reaplicarPerfil && _ctx.reaplicarPerfil(...args))),
                      style: {"width":"100%"}
                    }, "Reaplicar Perfil")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_14, [
            _createVNode(_component_a_skeleton, {
              loading: _ctx.telaBase.carregando
            }, {
              default: _withCtx(() => [
                (_ctx.telaBase.apresentarBarraProgresso)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_barra_progresso, {
                        frase: "Aguarde por favor, estamos salvando as permissões...",
                        visivel: _ctx.telaBase.apresentarBarraProgresso,
                        "onUpdate:visivel": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.telaBase.apresentarBarraProgresso) = $event))
                      }, null, 8, ["visivel"])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, [
                            _createVNode(_component_a_select, {
                              value: _ctx.state.valorAcaoMassa,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.valorAcaoMassa) = $event)),
                              class: "ss-tamanho-completo"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Habilitar")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 2 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Desabilitar")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_a_select, {
                              value: _ctx.state.codigoControleAcaoMassa,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.codigoControleAcaoMassa) = $event)),
                              class: "ss-tamanho-completo"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Todos")
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.listaControlePermissoes, (controle) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: 'opt.ctrl' + controle.tipoPermissao,
                                    value: controle.tipoPermissao
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(controle.descricao), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _hoisted_23,
                          _createElementVNode("div", _hoisted_24, [
                            _createVNode(_component_a_select, {
                              value: _ctx.state.codigoModuloAcaoMassa,
                              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.codigoModuloAcaoMassa) = $event)),
                              class: "ss-tamanho-completo"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 0 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Todos")
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.listaModulosControlePermissoes, (modulo) => {
                                  return (_openBlock(), _createBlock(_component_a_select_option, {
                                    key: 'opt.mdl' + modulo.codigo,
                                    value: modulo.codigo
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(modulo.titulo), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("button", {
                              onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.aplicarValorPermissoesEmMassa && _ctx.aplicarValorPermissoesEmMassa(...args))),
                              type: "button",
                              class: "ant-btn ant-btn-block ant-btn-primary"
                            }, " Aplicar ")
                          ]),
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_a_select, {
                              class: "ss-tamanho-completo",
                              value: _ctx.state.codigoPermissaoPesquisa > 0 ? _ctx.state.codigoPermissaoPesquisa : undefined,
                              "show-search": "",
                              placeholder: "Digite para localizar uma permissão",
                              "filter-option": false,
                              allowClear: true,
                              "not-found-content": _ctx.telaBase.fetching ? undefined : null,
                              options: _ctx.state.listaPermissoes,
                              onSearch: _cache[11] || (_cache[11] = ($event: any) => (_ctx.pesquisarPermissao($event))),
                              onChange: _ctx.localizarPermissao
                            }, _createSlots({ _: 2 }, [
                              (_ctx.telaBase.fetching)
                                ? {
                                    name: "notFoundContent",
                                    fn: _withCtx(() => [
                                      _createVNode(_component_a_spin, { size: "small" })
                                    ]),
                                    key: "0"
                                  }
                                : undefined
                            ]), 1032, ["value", "not-found-content", "options", "onChange"])
                          ])
                        ]),
                        _createVNode(_component_a_tabs, {
                          activeKey: _ctx.state.codigoTabControle,
                          "onUpdate:activeKey": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.codigoTabControle) = $event)),
                          tabPosition: "left"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.listaControlePermissoes, (controle) => {
                              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                                key: controle.tipoPermissao,
                                tab: controle.descricao
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_tabs, {
                                    activeKey: _ctx.state.codigoTabModulo,
                                    "onUpdate:activeKey": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.codigoTabModulo) = $event))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.modulos, (modulo) => {
                                        return (_openBlock(), _createBlock(_component_a_tab_pane, {
                                          key: (controle.tipoPermissao + modulo.codigo),
                                          tab: modulo.titulo
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modulo.categorias, (categoria) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: modulo.codigo + categoria.codigo
                                              }, [
                                                _createVNode(_component_card, {
                                                  titulo: categoria.descricao,
                                                  style: {"text-align":"left"}
                                                }, _createSlots({
                                                  default: _withCtx(() => [
                                                    (controle.tipoPermissao === _ctx.ETipoPermissao.Dados)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                                          _createElementVNode("div", _hoisted_29, [
                                                            _hoisted_30,
                                                            _createElementVNode("div", _hoisted_31, [
                                                              _createVNode(_component_a_checkbox, {
                                                                checked: categoria.visualizar,
                                                                "onUpdate:checked": ($event: any) => ((categoria.visualizar) = $event),
                                                                onClick: ($event: any) => (_ctx.manipularPermissoesDados($event.target.checked, modulo.codigo, categoria.codigo, _ctx.EPermissaoDados.Visualizar)),
                                                                class: "ss-display-controle-permissoes"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Visualizar")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["checked", "onUpdate:checked", "onClick"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_32, [
                                                              _createVNode(_component_a_checkbox, {
                                                                checked: categoria.incluir,
                                                                "onUpdate:checked": ($event: any) => ((categoria.incluir) = $event),
                                                                onClick: ($event: any) => (_ctx.manipularPermissoesDados($event.target.checked, modulo.codigo, categoria.codigo, _ctx.EPermissaoDados.Incluir)),
                                                                class: "ss-display-controle-permissoes"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Incluir")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["checked", "onUpdate:checked", "onClick"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_33, [
                                                              _createVNode(_component_a_checkbox, {
                                                                checked: categoria.alterar,
                                                                "onUpdate:checked": ($event: any) => ((categoria.alterar) = $event),
                                                                onClick: ($event: any) => (_ctx.manipularPermissoesDados($event.target.checked, modulo.codigo, categoria.codigo, _ctx.EPermissaoDados.Alterar)),
                                                                class: "ss-display-controle-permissoes"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Alterar")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["checked", "onUpdate:checked", "onClick"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_34, [
                                                              _createVNode(_component_a_checkbox, {
                                                                checked: categoria.excluir,
                                                                "onUpdate:checked": ($event: any) => ((categoria.excluir) = $event),
                                                                onClick: ($event: any) => (_ctx.manipularPermissoesDados($event.target.checked, modulo.codigo, categoria.codigo, _ctx.EPermissaoDados.Excluir)),
                                                                class: "ss-display-controle-permissoes"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Excluir")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["checked", "onUpdate:checked", "onClick"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_35, [
                                                              _createVNode(_component_a_checkbox, {
                                                                checked: categoria.imprimir,
                                                                "onUpdate:checked": ($event: any) => ((categoria.imprimir) = $event),
                                                                onClick: ($event: any) => (_ctx.manipularPermissoesDados($event.target.checked, modulo.codigo, categoria.codigo, _ctx.EPermissaoDados.Imprimir)),
                                                                class: "ss-display-controle-permissoes"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Imprimir")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["checked", "onUpdate:checked", "onClick"])
                                                            ])
                                                          ]),
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoria.permissoes, (permissao) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                              key: permissao.codigoPermissao,
                                                              class: "ant-row ss-borda-inferior"
                                                            }, [
                                                              _createElementVNode("div", _hoisted_36, [
                                                                _createElementVNode("span", {
                                                                  id: 'PER-' + permissao.codigoPermissao,
                                                                  class: "ss-display-controle-permissoes"
                                                                }, _toDisplayString(permissao.descricaoPermissao), 9, _hoisted_37)
                                                              ]),
                                                              _createElementVNode("div", _hoisted_38, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  onChange: ($event: any) => (_ctx.checarCategoriaPermissoesDados(modulo.codigo, categoria.codigo, _ctx.EPermissaoDados.Visualizar)),
                                                                  class: "ss-display-controle-permissoes",
                                                                  checked: permissao.visualizar,
                                                                  "onUpdate:checked": ($event: any) => ((permissao.visualizar) = $event)
                                                                }, null, 8, ["onChange", "checked", "onUpdate:checked"])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_39, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  onChange: ($event: any) => (_ctx.checarCategoriaPermissoesDados(modulo.codigo, categoria.codigo, _ctx.EPermissaoDados.Incluir)),
                                                                  class: "ss-display-controle-permissoes",
                                                                  checked: permissao.incluir,
                                                                  "onUpdate:checked": ($event: any) => ((permissao.incluir) = $event)
                                                                }, null, 8, ["onChange", "checked", "onUpdate:checked"])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_40, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  onChange: ($event: any) => (_ctx.checarCategoriaPermissoesDados(modulo.codigo, categoria.codigo, _ctx.EPermissaoDados.Alterar)),
                                                                  class: "ss-display-controle-permissoes",
                                                                  checked: permissao.alterar,
                                                                  "onUpdate:checked": ($event: any) => ((permissao.alterar) = $event)
                                                                }, null, 8, ["onChange", "checked", "onUpdate:checked"])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_41, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  onChange: ($event: any) => (_ctx.checarCategoriaPermissoesDados(modulo.codigo, categoria.codigo, _ctx.EPermissaoDados.Excluir)),
                                                                  class: "ss-display-controle-permissoes",
                                                                  checked: permissao.excluir,
                                                                  "onUpdate:checked": ($event: any) => ((permissao.excluir) = $event)
                                                                }, null, 8, ["onChange", "checked", "onUpdate:checked"])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_42, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  onChange: ($event: any) => (_ctx.checarCategoriaPermissoesDados(modulo.codigo, categoria.codigo, _ctx.EPermissaoDados.Imprimir)),
                                                                  class: "ss-display-controle-permissoes",
                                                                  checked: permissao.imprimir,
                                                                  "onUpdate:checked": ($event: any) => ((permissao.imprimir) = $event)
                                                                }, null, 8, ["onChange", "checked", "onUpdate:checked"])
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                                          _hoisted_44,
                                                          _createElementVNode("div", _hoisted_45, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoria.permissoes, (permissao) => {
                                                              return (_openBlock(), _createElementBlock("div", {
                                                                key: permissao.codigoPermissao,
                                                                class: "ant-col ant-col-xs-24 ant-col-xl-12"
                                                              }, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  onChange: ($event: any) => (_ctx.checarCategoriaPermissoes(modulo.codigo, categoria.codigo, controle.tipoPermissao)),
                                                                  class: "ss-display-controle-permissoes",
                                                                  checked: permissao.visualizar,
                                                                  "onUpdate:checked": ($event: any) => ((permissao.visualizar) = $event),
                                                                  disabled: !_ctx.state.permiteDesativarControlePermissoes && permissao.identificadorPermissao == 'AUT_CONTROLE_PERMISSOES_USUARIO'
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("span", {
                                                                      id: 'PER-' + permissao.codigoPermissao
                                                                    }, _toDisplayString(permissao.descricaoPermissao), 9, _hoisted_46)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["onChange", "checked", "onUpdate:checked", "disabled"])
                                                              ]))
                                                            }), 128))
                                                          ])
                                                        ]))
                                                  ]),
                                                  _: 2
                                                }, [
                                                  (controle.tipoPermissao !== _ctx.ETipoPermissao.Dados)
                                                    ? {
                                                        name: "AcoesExtra",
                                                        fn: _withCtx(() => [
                                                          _createVNode(_component_a_checkbox, {
                                                            style: {"margin-left":"5px"},
                                                            checked: categoria.visualizar,
                                                            "onUpdate:checked": ($event: any) => ((categoria.visualizar) = $event),
                                                            onClick: ($event: any) => (_ctx.manipularPermissoes($event.target.checked, modulo.codigo, categoria.codigo, controle.tipoPermissao))
                                                          }, null, 8, ["checked", "onUpdate:checked", "onClick"])
                                                        ]),
                                                        key: "0"
                                                      }
                                                    : undefined
                                                ]), 1032, ["titulo"])
                                              ]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["tab"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["activeKey"])
                                ]),
                                _: 2
                              }, 1032, ["tab"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["activeKey"])
                      ])
                    ]))
              ]),
              _: 1
            }, 8, ["loading"])
          ], 512), [
            [_vShow, _ctx.state.codigoUsuario > 0]
          ])
        ])
      ])
    ]),
    _createVNode(_component_requisicao_modal, {
      visivel: _ctx.modalBase.exibirRequisicaoModal,
      "onUpdate:visivel": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
      retornoRequisicao: _ctx.modalBase.retornoRequisicao,
      apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
      fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
    }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
  ]))
}